import { useUser } from "contexts/userContext/userContext";

const IL_COUNTRY = "Israel";

/**
 * Hook to check if the user is from Israel.
*/
const useIsIsraelUser = () => {
  const { getUserData, getIsIsrael } = useUser();

  const useIsFromIsrael =
    getUserData()?.UserCountry === IL_COUNTRY || getIsIsrael();

  return useIsFromIsrael;
};

export default useIsIsraelUser;
